import React from "react";
import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles()(() => ({
	text: {
		fontFamily: "Roboto",
		fontSize: "14px",
		color: "#4b5563",
		marginBottom: "16px",
	},
}));

const ReportSubscriptionsExplanation = () => {
	const { classes } = useStyles();
	const { t } = useTranslation();
	return (
		<Typography className={classes.text}>
			{t("message.reportSubscriptionsExplanation")}
		</Typography>
	);
};

export default ReportSubscriptionsExplanation;
